import * as React from 'react';

import * as styles from './styles.css';

export const ChatMessageLoader = () => {
  return <div data-testid="chat_message_loader" className={styles['loader']} />;
};
